import React from 'react';

const Footer = () => (
    <footer>
        Built by <a href="https://matthaynes.uk" target="_blank" rel="noopener noreferrer">Matt</a> &copy; 2020
    </footer>
);

export default Footer;
